import { ROUTES } from '@shared/utils';

const ID = ':id';

type GameRoutePattern = {
  gamePagePath: string;
  indexOfId: number;
};

/** Lazily built so incomplete test mocks do not crash module evaluation. */
function getGameRoutePattern(): GameRoutePattern | null {
  const gameBuilder = ROUTES.CASINO?.GAME;
  if (typeof gameBuilder !== 'function') {
    return null;
  }
  const gamePagePath = gameBuilder(ID);
  const indexOfId = gamePagePath.split('/').indexOf(ID);
  if (indexOfId < 0) {
    return null;
  }
  return { gamePagePath, indexOfId };
}

function normalizePath(path: string, indexOfId: number) {
  return path.split('/').toSpliced(indexOfId, 1).join('');
}

/**
 * matchGamePlayPathname checks if the given pathname is a game page path.
 * @param pathname - The pathname to check.
 * @returns True if the pathname is a game page path, false otherwise.
 */
function matchGamePlayPathname(pathname: string): boolean {
  const pattern = getGameRoutePattern();
  if (!pattern) return false;

  const { gamePagePath, indexOfId } = pattern;
  return normalizePath(pathname, indexOfId) === normalizePath(gamePagePath, indexOfId);
}

export { matchGamePlayPathname };
